import React, { Fragment } from "react";
await import("@css/loadingStyles.css");
const Loading = ({ classNames = "", element = "div" }) => {
  const classNameList = ["loading"];
  if (classNames) {
    classNameList.push(classNames);
  }
  switch (element) {
    case "tbody":
      return <tbody className={classNameList.join(" ")} />;
    case "button":
      return <button className={classNameList.join(" ")} />;
    case "tfoot":
      return <tfoot className={classNameList.join(" ")} />;
    case "li":
      return <li className={classNameList.join(" ")} />;
    case "h1":
      return <h1 className={classNameList.join(" ")} />;
    case "tr":
      return <tr className={classNameList.join(" ")} />;
    case "table":
      return <table className={classNameList.join(" ")} />;
    case "option":
      return <option className={classNameList.join(" ")} />;
    case "fragment":
      return <Fragment />;
    case "section":
      return <section className={classNameList.join(" ")} />;
    default:
      return <div className={classNameList.join(" ")} />;
  }
};
export default Loading;
